import { BasicStorageItem, Logger } from '@uploadcam/common';
import { DialogService, MessageType } from 'src/app/features/shared/services/dialog.service';
import { StorageProvider } from '../../storage.provider';
import { openNewTab, wait } from '../../../../app/core/utils';
import { FeaturesService } from '../../../../app/features/shared/services/features.service';
import { StorageEmbeddedEvent } from '../storage-embedded-event';

export class DownloadStorageFileInteractor {
  constructor(
    private readonly dialog: DialogService,
    private readonly features: FeaturesService,
    private readonly logger: Logger,
    private readonly postMessage: (event: StorageEmbeddedEvent) => void,
    private readonly provider: StorageProvider,
  ) {}

  public async execute(items: BasicStorageItem[]): Promise<void> {
    const closeFn = this.dialog.wait();

    try {
      const manager = await this.provider.provideManager();
      const urlsMap = await manager.getDownloadUrls(items);
      const maybeUrls = Object.values(urlsMap);
      const urls = maybeUrls.filter((url) => url !== undefined);

      if (urls.length !== maybeUrls.length) {
        this.dialog.snack('Some files are not available', MessageType.Warning);
      }

      if (this.features.context().isEmbedded) {
        this.postMessage({ type: 'storage-download', items });
      } else {
        for (const url of urls) {
          openNewTab(url);
          await wait(200);
        }
      }
    } catch (err) {
      this.logger.error(err);
      this.dialog.snack('Failed to download the file', MessageType.Error);
    } finally {
      closeFn();
    }
  }
}
